export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-50">
            关于我们
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            了解天美麻花星空影视的品牌故事与使命
          </p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="p-6 md:p-10 rounded-2xl bg-background-50 border border-background-300/20">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500/15">
                <i className="ri-movie-2-line text-primary-400 text-xl"></i>
              </div>
              <span className="text-lg font-heading font-bold text-foreground-100">
                天美麻花星空影视
              </span>
            </div>
            <div className="space-y-4 text-sm md:text-base text-foreground-400 leading-relaxed">
              <p>
                天美麻花星空影视成立于2024年，是一家专注于提供<strong className="text-foreground-200">免费高清在线影视</strong>服务的平台。我们致力于为用户打造一个内容丰富、画质卓越、播放流畅的一站式影视观看体验，让每一位观众都能轻松享受超清蓝光电视剧全集、热门电影大片、最新综艺动漫带来的视听盛宴。
              </p>
              <p>
                平台目前已收录超过<strong className="text-foreground-200">10万+部影视资源</strong>，涵盖国产剧、韩剧、美剧、日剧、电影、综艺、动漫、纪录片等多个频道。所有内容均提供超清蓝光画质选项，支持大屏TV版播放，让家庭观影体验更加震撼。
              </p>
              <p>
                我们始终坚持"免费、高清、流畅"的服务理念，通过技术创新不断优化播放体验，实现多端同步、不缓冲秒播。天美麻花星空影视每日更新热门内容，确保用户第一时间看到最新剧集和电影大片。未来，我们将继续扩充资源库，引入更多优质内容，成为您最信赖的免费在线影视平台。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}